/* globals Intercom $ */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { escapeHTML } from '~go/web/src/js/utils/Helpers';
import CSRF from '../classes/CSRF';
import NavBar from '../classes/NavBar';
import ShowOnScroll from '../classes/ShowOnScroll';
import ExternalAppSwitcher from '../external_components/external_app_switcher/external_app_switcher';
import CookieBanner from '../external_components/cookie_banner';
import ErrorLogging from '../classes/ErrorLogging';
import '~go/web/src/js/utils/window_open_override';

/**
 * class that needs to be run on most or all external pages
 * USE THIS SPARINGLY
 */
class External {
  constructor() {
    // Initialize navbar
    const navBar = new NavBar();
    navBar.init();

    // Initialize display on scroll animations
    const showOnScroll = new ShowOnScroll();
    showOnScroll.init();

    new CSRF().setHeader();

    ErrorLogging.setupProductionErrorLogging();

    const cookieBanner = $('.CookieBanner')[0];
    if (cookieBanner) {
      createRoot(cookieBanner).render(<CookieBanner />);
    }

    const customStyle = document.querySelector('#custom-style');
    if (customStyle) {
      customStyle.onerror = function handleStylesNotLoadingError() {
        document.querySelector('#bootstrap-fallback').removeAttribute('disabled');
      };
    }

    // Renders app switcher on all external landing pages
    const externalAppSwitcher = document.getElementById('ExternalAppSwitcher');
    if (externalAppSwitcher) {
      createRoot(externalAppSwitcher).render(<ExternalAppSwitcher />);
    }

    document.querySelectorAll('.disabled-onload').forEach(item => {
      item.removeAttribute('disabled');
    });

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    // Intercom chat
    this.interactIntercomChat();
  }

  /**
   * Listen to intercom chat button click
   * - To open intercom chat with a message, add `chat-now` class to the element and an optional `data-message` attribute
   */
  interactIntercomChat() {
    $(() => {
      $('.chat-now').on('click', e => {
        if (!Intercom) {
          return;
        }
        e.preventDefault();
        const message = escapeHTML($(e.target).data('message'));

        Intercom('showNewMessage', message);
      });
    });
  }
}

export default new External();
